import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Tab, Nav, Badge, Dropdown, Button, Carousel } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ManageLeadSource = () => {


    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [loading, setLoading] = useState(true);

    const [yeardisplay, setyeardisp] = useState(new Date());
    const [year, setyear] = useState(new Date().getFullYear());

    const handleYearChange = (date) => {
        const selectedYear = date.year;
        setyear(selectedYear);
        setyeardisp(date); // Set for DatePicker display
    };

    const months = [
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ];

    const [data, setdata] = useState([])

    const [totals, setTtoals] = useState(Array(12).fill(null));

    const [grandTotal, setGrandTotal] = useState({ leads: 0, customers: 0, conversion: "0%" });

    const [source_count, setcount] = useState(0);

    // page table data fetch
    const fetchData = () => {
        setLoading(true);
        const post_data = { year: year, branch_id: branch_id }
        axios.post(`${baseURL}/get_year_leadsource`, post_data)
            .then(response => {
                setdata(response.data.data);
                setTtoals(response.data.totals);
                setGrandTotal(response.data.grandTotal);
                setcount(response.data.totalsource);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        if (year) {
            fetchData();
        }
    }, [year]);

    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "leadsource"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Lead Source </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>

            {loading ? (
                <div className="d-flex justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0 align-content-center'>
                        <div className="mb-0 px-0">
                            <Skeleton width={200} height={28} /> {/* Title */}
                        </div>
                        <div className="d-flex gap-1 mt-1">
                            <Skeleton width={60} height={16} /> {/* Breadcrumb item */}
                            <Skeleton width={16} height={16} /> {/* Arrow */}
                            <Skeleton width={100} height={16} /> {/* Active breadcrumb */}
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end mb-1">
                        <div className="w-60 mb-1 col-lg-8">
                            <div className='datepicker-wrapper d-flex align-items-center gap-1'>
                                <Skeleton circle width={36} height={36} /> {/* Calendar icon */}
                                <Skeleton width={120} height={36} /> {/* Date input */}
                                <Skeleton circle width={36} height={36} /> {/* Caret icon */}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                    <div className='mb-0'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Lead Source</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>

                    {permissions.source_list === 1 && (
                        <div class="d-flex align-items-center justify-content-end mb-1">
                            <div class="w-60 mb-1 col-lg-6">
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker format="YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyYearPicker={true} onChange={handleYearChange} minDate={new Date(1900, 0, 1)} maxDate={new Date()} />
                                    <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {permissions.source_list === 1 && (
                <>
                    {loading ? (
                        <div className="table-container">
                            <div className="attendance-table-container">
                                <div className="table-scroll-wrapper">
                                    <table
                                        className="table custom-attendance-table table-row-dashed table-striped table-hover"
                                        style={{ outline: "0.5px solid rgba(0, 0, 0, 0.5)" }}
                                    >
                                        <thead>
                                            <tr className="text-start fw-bold fs-6 gs-0 th_head">
                                                <th><Skeleton width={100} height={16} /></th>
                                                {months.map((_, i) => (
                                                    <th><Skeleton width={100} height={16} /></th>
                                                ))}
                                                <th><Skeleton width={100} height={16} /></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Array.from({ length: 25 }).map((_, rIndex) => (
                                                <tr key={rIndex}>
                                                    <td
                                                        className="sticky-col left-col"
                                                        style={{ backgroundColor: "#D8D8D8" }}
                                                    >
                                                        <Skeleton width={120} height={18} />
                                                    </td>

                                                    {months.map((_, cIndex) => (
                                                        <td key={cIndex} className="text-start">
                                                            <div className="d-flex align-items-center gap-1">
                                                                <Skeleton width={25} height={16} />
                                                                <Skeleton width={25} height={16} />
                                                                <Skeleton width={25} height={16} />
                                                            </div>
                                                        </td>
                                                    ))}

                                                    <td className="sticky-col right-col bg-light text-start px-2 py-2">
                                                        <div className="d-flex align-items-center gap-1">
                                                            <Skeleton width={25} height={16} />
                                                            <Skeleton width={25} height={16} />
                                                            <Skeleton width={25} height={16} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot>
                                            <tr className="footer-row text-start fw-bold fs-6 gs-0 th_head">
                                                <td className="sticky-col left-col text-white bg-primary min-w-150px text-start px-2 py-2">
                                                    <Skeleton width={100} height={16} baseColor="#b3b3b3" />
                                                </td>

                                                {months.map((_, i) => (
                                                    <td key={i} className="text-white bg-primary text-center">
                                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                                            <Skeleton width={25} height={16} />
                                                            <Skeleton width={25} height={16} />
                                                            <Skeleton width={25} height={16} />
                                                        </div>
                                                    </td>
                                                ))}

                                                <td className="sticky-col right-col bg-primary text-white text-start px-2 py-2">
                                                    <div className="d-flex align-items-center gap-1">
                                                        <Skeleton width={30} height={16} />
                                                        <Skeleton width={30} height={16} />
                                                        <Skeleton width={30} height={16} />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                    <Skeleton width={200} height={16} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="table-container">

                            <div className="attendance-table-container">
                                <div className="table-scroll-wrapper">
                                    <table className="table custom-attendance-table table-row-dashed table-striped table-hover" style={{ outline: '0.5px solid rgba(0, 0, 0, 0.5)' }}>
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className="sticky-col left-col bg-primary  text-white min-w-150px text-start px-2 py-2"
                                                //  style={{ backgroundColor: '#6D788D '}}
                                                >Lead Source</th>
                                                {months.map((month) => (
                                                    <th key={month} className='text-white bg-primary'
                                                    // style={{ backgroundColor: '#099DDA'}}
                                                    >{month}</th>
                                                ))}
                                                <th className="sticky-col right-col text-white min-w-150px text-start px-2 py-2 bg-primary"
                                                // style={{ backgroundColor: '#6D788D '}}
                                                >Overall Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td className="sticky-col left-col" style={{ backgroundColor: '#D8D8D8' }}>
                                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                                            <label className='text-black font-w600 fs-7'>{row.source}</label>
                                                        </div>
                                                    </td>

                                                    {row.months.map((cell, i) => (
                                                        <td key={i} className='text-start'>
                                                            {cell ? (
                                                                <>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Leads</span> </Tooltip>}>
                                                                        <label className="badge bg-info rounded-pill fs-7">{cell.leads}</label>
                                                                    </OverlayTrigger>
                                                                    <label className="text-black fw-semibold fs-7 mx-1">/</label>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Customers</span> </Tooltip>}>
                                                                        <label className="badge bg-success text-black rounded-pill fs-7">{cell.customers}</label>
                                                                    </OverlayTrigger><label className="text-black fw-semibold fs-7 mx-1">/</label>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Conversion Percentage</span> </Tooltip>}>
                                                                        <label className="badge bg-warning rounded-pill fs-7">{cell.conversion}</label>
                                                                    </OverlayTrigger>
                                                                </>
                                                            ) : (
                                                                <div className="text-center align-content-center">-</div>
                                                            )}
                                                        </td>
                                                    ))}

                                                    {row.total.leads > 0 ? (
                                                        <td className="sticky-col bg-success right-col min-w-150px text-start px-2 py-2">
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Leads</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.leads}</label>
                                                            </OverlayTrigger>
                                                            <label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Customers</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.customers}</label>
                                                            </OverlayTrigger><label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Conversion Percentage</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.conversion}</label>
                                                            </OverlayTrigger>
                                                        </td>
                                                    ) : (
                                                        <td className="sticky-col bg-danger right-col min-w-150px text-start px-2 py-2">
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Leads</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.leads}</label>
                                                            </OverlayTrigger>
                                                            <label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Customers</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.customers}</label>
                                                            </OverlayTrigger><label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Conversion Percentage</span> </Tooltip>}>
                                                                <label className="text-white fw-bold rounded-pill fs-7">{row.total.conversion}</label>
                                                            </OverlayTrigger>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="footer-row text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <td className="sticky-col left-col text-white min-w-150px text-start px-2 py-2 bg-primary"
                                                // style={{ backgroundColor: '#6D788D'}}
                                                >Overall Total</td>

                                                {totals.map((cell, i) => (
                                                    <td key={i} className='text-white bg-primary'
                                                    // style={{ backgroundColor: '#099DDA'}}
                                                    >
                                                        {cell ? (
                                                            <>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Leads</span> </Tooltip>}>
                                                                    <label className="text-white rounded-pill fs-7">{cell.leads}</label>
                                                                </OverlayTrigger>
                                                                <label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Customers</span> </Tooltip>}>
                                                                    <label className=" text-white rounded-pill fs-7">{cell.customers}</label>
                                                                </OverlayTrigger>
                                                                <label className="text-white fw-semibold fs-7 mx-1">/</label>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Conversion Percentage</span> </Tooltip>}>
                                                                    <label className="text-white rounded-pill fs-7">{cell.conversion}</label>
                                                                </OverlayTrigger>
                                                            </>
                                                        ) : (
                                                            <div className="text-center align-content-center">-</div>
                                                        )}
                                                    </td>
                                                ))}

                                                <td className="sticky-col right-col bg-primary text-white text-start px-2 py-2">
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Leads</span> </Tooltip>}>
                                                        <label className=" rounded-pill fs-6">{grandTotal.leads}</label>
                                                    </OverlayTrigger>
                                                    <label className="text-white fw-semibold fs-6 mx-1">/</label>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Total Customers</span> </Tooltip>}>
                                                        <label className=" text-white rounded-pill fs-6">{grandTotal.customers}</label>
                                                    </OverlayTrigger>
                                                    <label className="text-white fw-semibold fs-6 mx-1">/</label>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Average Conversion Percentage</span> </Tooltip>}>
                                                        <label className=" rounded-pill fs-6">{grandTotal.conversion}</label>
                                                    </OverlayTrigger>
                                                </td>

                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    <span className="text-muted">
                                        Showing {source_count > 0 ? '1' : '0'} to {source_count} of {source_count} entries
                                    </span>
                                </div>
                            </div>

                        </div>
                    )}
                </>
            )}

            {permissions.source_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )

}
export default ManageLeadSource;